module.exports = __webpack_public_path__ + "static/media/paymentPages.dc420431.svg";